/**
 * File to store all the survey's static data from all steps (in case they'll be indeed static data).
 * */

export const SURVEY_DATA = {
    // Overall buying experience rating
    initialSteps: {
        ratings: [1, 2, 3, 4, 5],
        improvableOptions: [
            {
                id:    "io-0",
                label: "Melhorias na busca"
            },
            {
                id:    "io-1",
                label: "Site lento"
            },
            {
                id:    "io-2",
                label: "Detalhes sobre produto ou serviço"
            },
            {
                id:    "io-3",
                label: "Falta informações"
            },
            {
                id:    "io-4",
                label: "Fluxo de compra confuso"
            },
            {
                id:    "io-5",
                label: "Suporte técnico"
            },
            {
                id:    "io-6",
                label: "Mais opções de pagamento"
            },
            {
                id:    "io-7",
                label: "Melhorar a acessibilidade"
            }
        ],
        enjoyableOptions: [
            {
                id:    "eo-0",
                label: "Encontrei tudo que eu precisava"
            },
            {
                id:    "eo-1",
                label: "Busca por produto/serviço"
            },
            {
                id:    "eo-2",
                label: "Site rápido"
            },
            {
                id:    "eo-3",
                label: "Boa navegação"
            },
            {
                id:    "eo-4",
                label: "Opções de pagamento"
            },
            {
                id:    "eo-5",
                label: "Acessível"
            },
            {
                id:    "eo-6",
                label: "Opções de parcelamento"
            },
            {
                id:    "eo-7",
                label: "Melhorar a acessibilidade"
            }
        ]
    },
    thirdStep: {

    },
    fourthStep: {
        options: [
            {
                id: 1,
                label: "Google"
            },
            {
                id: 2,
                label: "Redes Sociais"
            },
            {
                id: 3,
                label: "Indicaçao do Atendimento Presencial"
            },
            {
                id: 4,
                label: "Indicação do Médico"
            },
            {
                id: 5,
                label: "Amigos/Familiares"
            },
            {
                id: "others",
                label: "Outros"
            }
        ]
    },
    fifthStep: {

    }
}
